import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import "./CustomerList.css";

const LS_KEY = "app_users_v1";

function getUserById(id) {
  const users = JSON.parse(localStorage.getItem(LS_KEY)) || [];
  return users.find(u => u.id === Number(id));
}

function updateUserInLocalStorage(updatedUser) {
  const users = JSON.parse(localStorage.getItem(LS_KEY)) || [];
  const updatedUsers = users.map(u => (u.id === updatedUser.id ? updatedUser : u));
  localStorage.setItem(LS_KEY, JSON.stringify(updatedUsers));
}

const EditPrivilegeUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    email: "",
  });

  useEffect(() => {
    const user = getUserById(id);
    if (user) {
      setFormData({
        name: user.name,
        designation: user.designation,
        email: user.email,
      });
    } else {
      alert("User not found");
      navigate("/settings");
    }
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.designation || !formData.email) {
      alert("Please fill all fields");
      return;
    }

    const updatedUser = {
      id: Number(id),
      ...formData,
      privileges: getUserById(id)?.privileges || {},
    };

    updateUserInLocalStorage(updatedUser);
    navigate("/settings");
  };

  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Edit Privilege User</h4>
        <Button variant="secondary" onClick={() => navigate(-1)}>Back</Button>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter name"
                required
              />
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                placeholder="Enter designation"
                required
              />
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">Update</Button>
          <Button variant="outline-secondary" onClick={() => navigate(-1)}>Cancel</Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditPrivilegeUser;
